const SAFE_URL_PROTOCOLS = ["https:", "http:", "mailto:", "tel:"];
const FALLBACK_URL = "#";

export const sanitizeUrl = (url: string | undefined | null): string => {
  if (!url) return FALLBACK_URL;

  try {
    const parsed = new URL(url, window.location.origin);
    return SAFE_URL_PROTOCOLS.includes(parsed.protocol) ? url : FALLBACK_URL;
  } catch {
    return FALLBACK_URL;
  }
};

const MONDAY_AUTH_ORIGIN = "https://auth.monday.com";

// The authorize flow now starts at our own backend (`/oauth/authorize`), which
// sets up PKCE and 302-redirects to Monday — so the backend origin must also be
// trusted, alongside Monday's own authorize origin.
const BACKEND_ORIGIN = (() => {
  try {
    return process.env.REACT_APP_URI ? new URL(process.env.REACT_APP_URI).origin : null;
  } catch {
    return null;
  }
})();

export const isTrustedAuthUrl = (url: string | undefined | null): boolean => {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "https:") return false;
    return parsed.origin === MONDAY_AUTH_ORIGIN || parsed.origin === BACKEND_ORIGIN;
  } catch {
    return false;
  }
};
